import MyClaimsListPageActionTypes from './my-claims-list-page-action-types';
import axios from 'axios';
import ForbiddenError from '../../../utils/forbidden-error';

export const loadMyClaimsListPage = () => async(dispatch) => {
  dispatch(findMyClaims());
};

export const findMyClaims = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_START });
  const state = getState().myGeneralCompetencyClaimsListPage;
  const query = {
    skip: payload ? payload.skip : state.skip,
    limit: payload ? payload.take : state.take
  };
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const result = await api.get('api/my_general_competency_claims', query, state.cancelToken.token);
    dispatch({
      type: MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_END,
      payload: {
        claims: result ? result.data.map(c => ({ ...c, occurredAt: c.occurredAt ? new Date(c.occurredAt.substring(0, 10) + 'T12:00:00') : null })) : [],
        total: result ? result.total : 0,
        skip: payload ? payload.skip : state.skip,
        take: payload ? payload.take : state.take
      }
    });
  } catch (error) {
    if (error instanceof ForbiddenError) {
      dispatch({ type: MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_END });
    } else if (!(error instanceof axios.Cancel)) {
      dispatch({ type: MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_END });
      throw error;
    }
  }
};

export const openDeleteClaimDialog = (id) => (dispatch) => {
  dispatch({ type: MyClaimsListPageActionTypes.SELECT_MY_CLAIM, payload: { selectedClaimId: id } });
  dispatch({ type: MyClaimsListPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG });
};

export const closeDeleteClaimDialog = () => (dispatch) => {
  dispatch({ type: MyClaimsListPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG });
};

export const confirmDeleteClaim = () => async(dispatch, getState, { api }) => {
  const state = getState().myGeneralCompetencyClaimsListPage;
  if (state.selectedClaimId > 0) {
    dispatch({ type: MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_START });
    try {
      await api.remove(`api/my_general_competency_claims/${state.selectedClaimId}`);
      dispatch(findMyClaims());
    } catch (error) {
      dispatch({ type: MyClaimsListPageActionTypes.LOAD_MY_CLAIMS_LIST_PAGE_END });
    }
  }
  dispatch({ type: MyClaimsListPageActionTypes.TOGGLE_DELETE_CLAIM_DIALOG });
};
